import { defaults } from '../defaults';
/**
 * Propsy związane z opsiami/komunikatami
 */
export const withSchemaDisplayConfigProps = {
  /** Wyświetlaj oznaczenie pola jako wypełnione poprawnie */
  displaySuccess: { type: Boolean, default: defaults.schema.displaySuccess },

  /**
   * Czy wyświetlać błędy
   */
  displayValidation: { type: Boolean, default: true },

  /**
   * Czy wyświetlać opis
   */
  displayDescription: { type: Boolean, default: true },

  /**
   * Czy wyświetlać etykietę
   */
  displayLabel: { type: Boolean, default: true },

  /**
   * Dodatkowe identyfikatory do przekazania do `aria-describedby`
   */
  describedBy: { type: String, default: '' }
} as const;

/**
 * Konfiguracja dla storybooka
 */
export const storiesSchemaDisplayConfigArgs = {
  args: {
    displaySuccess: defaults.schema.displaySuccess,
    displayLabel: true,
    displayValidation: true,
    displayDescription: true
  },

  argTypes: {
    displaySuccess: {
      control: { type: 'boolean' }
    },

    displayLabel: {
      control: { type: 'boolean' }
    },

    displayValidation: {
      control: { type: 'boolean' }
    },

    displayDescription: {
      control: { type: 'boolean' }
    }
  }
};
